import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { ImageListModal, ImageModal } from '@/shared/components/ui/Images';
import {
  EstadosImagenChoiceEnum,
  calcOTImages,
  solicitudUpdFotosSchema,
} from '@/shared';
import { useUpdateOrdenTrabajo } from '@/shared/actions/erp';
import { UpdFotosSalidaRequestData } from '@/shared/actions/erp/tecnico';
import { TabTextLabel } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { OrdenTrabajo } from '@/shared/interfaces';
import ConfirmUpdFotosAlertActivacionFotosModal from './ConfirmUpdFotosAlertActivacionFotosModal';

export type FotosSalidaSubidaOTModalProps = {
  ordenTrabajo: OrdenTrabajo;
  open: boolean;
  onClose: () => void;
};

type FormData = {
  comentario_solicita_upd_fotos: string;
  fecha_solicita_upd_fotos: string;
  usuario_solicita_upd_fotos: number;
};

const FotosSalidaSubidaOTModal: React.FC<FotosSalidaSubidaOTModalProps> = ({
  open,
  ordenTrabajo,
  onClose,
}) => {
  ///* local state ------------
  const [imagesArr, setImagesArr] = useState<ImageModal[]>([]);
  const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);

  ///* form ------------
  const form = useForm<FormData>({
    resolver: yupResolver(solicitudUpdFotosSchema) as any,
    defaultValues: {
      fecha_solicita_upd_fotos: dayjs().format(),
    },
  });

  ///* mutations ------------
  const updOtFotosSalida = useUpdateOrdenTrabajo<UpdFotosSalidaRequestData>({
    enableRedirect: false,
    customSuccessMessage:
      'Solicitud de actualización de fotos enviada con éxito',
  });

  ///* handlers ------------
  const handleUpdRequest = async (data: FormData) => {
    updOtFotosSalida.mutate({
      id: ordenTrabajo?.id_orden_trabajo!,
      data: {
        estado_imagen_salida: EstadosImagenChoiceEnum.UPD_SOLICITADA,
        estado_imagen_actualizacion: EstadosImagenChoiceEnum.UPD_SOLICITADA,
        observaciones: {
          ...ordenTrabajo?.observaciones,
          observacion_foto_salida_upd_sol: data.comentario_solicita_upd_fotos,
        },
      },
    });

    onClose();
  };

  ///* effects ------------
  useEffect(() => {
    if (!open) return;

    // antes era async
    const photesEntrada = calcOTImages(ordenTrabajo, 'urls_fotos_salida');
    setImagesArr(photesEntrada);
  }, [open]);

  return (
    <>
      <ScrollableDialogProps
        open={open}
        title="Fotos de Salida"
        minWidth="54%"
        minHeight="30vh"
        contentNode={
          <>
            <Grid item xs={12} container spacing={3}>
              <>
                {/* ----- Image Modal ----- */}
                <Grid item xs={12}>
                  <TabTextLabel text="Fotos de Salida" pt="0" pl="0" pb="0" />
                </Grid>
                <ImageListModal images={imagesArr || []} />
              </>
            </Grid>
          </>
        }
        onClose={onClose}
        cancelTextBtn="Cerrar"
        // onConfirm to request new images
        onConfirm={() => {
          setIsOpenConfirmDialog(true);
        }}
        confirmTextBtn="Solicitar Actualización de Fotos"
        confirmBtnColor="error"
      />

      {/* ========= confirm dialog ========= */}
      <ConfirmUpdFotosAlertActivacionFotosModal
        form={form}
        handleConfirm={handleUpdRequest}
        isOpenConfirmDialog={isOpenConfirmDialog}
        setIsOpenConfirmDialog={setIsOpenConfirmDialog}
        isSalida
      />
    </>
  );
};

export default FotosSalidaSubidaOTModal;
